const ClearInput = (el) => {
  if (el !== null) {
    const input = el
    input.value = ''
  }
}

export default ClearInput
